import { apiRequest } from '../../lib/api'
import { getApiUrl } from '../../apiService'

export type EmbedInfo = { embedToken?: string; embedUrl?: string }

export async function fetchEmbedInfo(id: string | undefined): Promise<EmbedInfo | undefined> {
  try {
    const tokenResponse = await apiRequest(
      `${getApiUrl()}/${id ? `bots/${id}/` : ''}powerbi-embed-token`,
      {
        checkOk: true,
        requireToken: true
      }
    )

    return tokenResponse
  } catch (error) {
    console.error('Cannot fetch Power BI token', (error as Error)?.message)
  }
}

export function isInstanceAnalyticsEnabledByWindowFeatureFlag(): boolean {
  return !!window.FEATURE_INSTANCE_ANALYTICS
}
